import { useEffect, useState } from 'react';

const OPEN_TIMEOUT = 50;

const useDelayedOpening = () => {
	const [ opened, setOpened ] = useState( false );

	useEffect( () => {
		const timeout = setTimeout( () => setOpened( true ), OPEN_TIMEOUT );
		return () => { clearTimeout( timeout ); };
	}, [] );

	return opened;
}

export default useDelayedOpening;
